import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormField, FormFieldOption } from '../../../dto/util/form-field';

@Component({
  selector: 'app-modal-select-tipo-usuario',
  templateUrl: './modal-select-tipo-usuario.component.html',
  styleUrl: './modal-select-tipo-usuario.component.scss',
})
export class ModalSelectTipoUsuarioComponent implements OnInit {
  @ViewChild('modalSeleccionTipoUsuario')
  modalSeleccionTipoUsuario!: ElementRef;

  @Input() tiposUsuario: FormFieldOption[] = [];
  @Output() tipoUsuarioEmitter = new EventEmitter<number>();
  fieldsTiposDeUsuario: FormField[] = [];

  ngOnInit(): void {
    this.creacionFormulario();
  }

  async creacionFormulario() {
    this.fieldsTiposDeUsuario = [
      {
        name: 'tipoUsuario',
        label: 'Tipo de Usuario',
        type: 'select',
        multiple: false,
        required: true,
        options: this.tiposUsuario,
        width: '12',
        visible: true,
        errorMessages: { required: 'El tipo de usuario es requerido' },
      },
    ];
  }

  onSubmitSeleccionarTipoUsuario(form: FormGroup) {
    const tipoUsuarioSeleccionado = form.get('tipoUsuario')?.value;
    this.tipoUsuarioEmitter.emit(tipoUsuarioSeleccionado);
  }

  abrirCerrarModal() {
    this.modalSeleccionTipoUsuario.nativeElement.click();
  }
}
